import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SandalsMenu from 'js/components/global/menu/sandals/MainMenu';
import constants from 'js/modules/constants';
import CobrandBar from 'js/components/global/CobrandBar';
import Moxie from 'js/components/global/Moxie';
import Tracker from 'js/components/global/Tracking';
import utils from 'js/modules/utils';
import cm from 'js/modules/cm';
import OutsideClickHandler from 'react-outside-click-handler';
import Accounts from './Accounts';
import DataService from '../../modules/dataservice';
import { numberWithCommas } from '../../modules/utils';
import GTMCookie from './GTMCookie';
import moment from 'moment';

const { sandals, beaches } = constants.brand;
const { url } = window._app.brandOptions;
const isMobile = window.innerWidth < 768;
const step = window._app.page.step;

class Header extends Component {
  constructor(props) {
    super(props);

    this.elHtml = document.querySelector('html');
    this.elBody = document.querySelector('body');
    this.loginSection = React.createRef();
  }

  state = {
    isOpen: false,
    account: {
      firstName: '',
      points: 0,
      level: '',
      signIn: false,
      id: 0
    },
    showLogin: false,
    showProfile: false,
    accountsLinks: [],
    showSignOutVerbiage: false,
    loading: false,
    accountServiceStatus: true,
    checkInDate: '',
    checkOutDate: ''
  };

  async componentDidMount() {
    cm.cmCreatePageviewTag();

    const { sandalsAccountActive = true } = await DataService.isAccountServicesActive();
    const summaryResponse = await DataService.readSummary();

    if(summaryResponse.code === 1 && summaryResponse.content.vacationData) {
      const {
        checkInDate = '',
        checkOutDate = ''
      } = summaryResponse.content.vacationData;

      this.setState({
        checkInDate: checkInDate,
        checkOutDate: checkOutDate
      });
    }

    if(sandalsAccountActive) {
      const accountsResponse = await DataService.getPrimaryAccount();
      const accountPointsResponse = await DataService.getAccountPoints();
      const accountStrapiResponse = await DataService.getAccountStrapiData(); // ACCOUNTS STRAPI DATA.

      if(Object.keys(accountStrapiResponse).length > 0) {
        const modules =  accountStrapiResponse.data.modules;
        const layoutMenu = modules.find((module) => module.__component === 'layout.menu');

        this.setState({accountsLinks: layoutMenu.links});
      }

      if(accountsResponse.status === 200 && accountPointsResponse.status === 200) {

        const profilesData = accountsResponse.content;
        const responseData = profilesData.primary_member;
        const pointsData = accountPointsResponse.content;
        const accountNumber = profilesData.account_number;

        const account = {
          firstName: responseData.first_name,
          points: pointsData.points_available,
          level: profilesData.member_level,
          signIn: true,
          id: accountNumber
        };

        this.setState({account: account});
      }
    }
    this.setState({accountServiceStatus: sandalsAccountActive});
  }

  _handleOutsideClick = () => {

    const { showProfile, showLogin } = this.state;
    const noScroll = 'util-no-flow';

    if (showProfile || showLogin) {
      utils.removeClass(this.elHtml, noScroll);
      utils.removeClass(this.elBody, noScroll);

      this.setState({ showProfile: false, showLogin: false });
    }
  };

  _logoIcon = () => {
    const options = {
      [`${sandals}`]: {
        logo: 'icon-new-sandals',
        slogan: '',
      },
      [`${beaches}`]: { logo: 'icon-new-beaches', slogan: '' },
    }[this.props.brand];

    return (
      <Fragment>
        <i className={options.logo} />
        {options.slogan && <span>{options.slogan}</span>}
      </Fragment>
    );
  };

  _renderMenu = () => {
    return <SandalsMenu />;
  };

  _showLogin = () => {
    const { showLogin } = this.state;

    this.setState({showLogin: !showLogin});
  }

  _showProfile = () => {
    const { showProfile } = this.state;

    this.setState({showProfile: !showProfile});
  }

  _createAccountOptions = () => {
    const urlBase = 'https://tstaccounts.sandals.com/my-account/';
    const { accountsLinks } = this.state;

    const accountOptions = accountsLinks.map((link) => {
      const linkIcon = link.logo.name.replace('.svg', '');

      return {
        name: link.label,
        href: link.href,
        icon: `icon-acc-${linkIcon}`
      };
    });

    const accountOptionsJSX = accountOptions.map((option, index) => <div key={index + 'opt'} className="option"><a href={urlBase + option.href} target="_blank"> <i className={option.icon} /> {option.name}</a></div>);

    return accountOptionsJSX;
  }
  _signOutAccounts = async() => {
    const status = await DataService.signOutAccounts();
    const account = {
      firstName: '',
      points: 0,
      level: '',
      signIn: false
    };

    this.setState({account: account});

    return status;
  }
  _showSignOutVerbiage = () => {

    this.setState({showSignOutVerbiage: true});
  }

  _closeSignOutVerbiage = () => {
    this.setState({showSignOutVerbiage: false});
  }

  _closeSession = async() => {
    const response = await this._signOutAccounts();

    this.setState({loading: true});

    if(Object.keys(response).length > 0) {
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    }
  }
  renderSteps = () => {
    // Define step options
    const options = {
      step1: { url: '/', title: 'Vacation' },
      step2: { url: '/room/', title: 'Room' },
      step3: { url: '/flights/', title: 'Flights' },
      step4: { url: '/guests/', title: 'Guests' },
      step5: { url: '/payment/', title: 'Payment' },
    };

    /* 14 days restriction header */
    const minFlightDate = moment().add(14, 'days');
    const checkInDate = this.state.checkInDate;
    const startDate = moment(checkInDate, constants.DB_DATE_FORMAT);
    const validDate = checkInDate ? startDate > minFlightDate : true;
    let currentStep = step;

    if(!validDate) {
      delete options.step3;
      if(step > 2) {
        currentStep--;
      }
    }

    // Render steps
    return (
      <ul className={`steps sm-12 ${!validDate ? 'reduce-bar' : ''}`}>
        {Object.values(options).map((item, index) => (
          <li key={index} className={index + 1 === currentStep ? 'active' : ''}>
            {index <= currentStep - 2 ? (
              // If index + 1 equals window._app.page.step
              <a className={'preview-step'} href={`${item.url}?subSessionId=${window._app.results.subSessionId || ''}`}>
                <i className="icon-new_checkmark"/>
                <span className="step-name">{item.title}</span>
              </a>
            ) : (
              <Fragment>
                <i className="icon-new_checkmark"/>
                <span className="step-name">{item.title}</span>
              </Fragment>
            )}
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { isBeaches } = window._app.brandOptions;
    const brand = isBeaches ? 'Beaches' : 'Sandals';
    const { showLogin, account, /* showProfile,*/  showSignOutVerbiage, loading, accountServiceStatus } = this.state;
    const pointsLabel = isMobile ? 'Points: ' : 'Available Points Balance: ';
    const levelLabel = isMobile ? 'Level: ' : 'Level Status: ';

    return (
      <OutsideClickHandler onOutsideClick={this._handleOutsideClick}>
        {showSignOutVerbiage &&
          <div className="sign-out-warning">
            <div className="content">
              <div className="close-information">
                <button className="close-btn" onClick={this._closeSignOutVerbiage}><i className="icon-close-simple"/></button>
              </div>
              <div className="information">
                <p className="question">Are you sure you want to sign out?</p>
                <p className="message">Any trip details provided will be reset.</p>
              </div>
              <div className="options">
                <button className="cancel" onClick={this._closeSignOutVerbiage}>Cancel</button>
                {!loading &&
                  <button className="continue" onClick={this._closeSession}>Sign Out</button>
                }
                {loading &&
                <div className="loader-container">
                  <div className="sign-in-loader"/>
                </div>
                }
              </div>
            </div>
          </div>
        }
        <Moxie />
        <Tracker />
        <GTMCookie />
        <CobrandBar />
        <div className={`header ${showLogin ? 'apply-sticky' : ''}`}>
          <div className="container">
            <div className="logo-container sm-5 md-8 lg-9">
              <h1 className="logo lg-3 md-4 sm-4">
                <a href={url}>{this._logoIcon()}</a>
              </h1>
            </div>
            {accountServiceStatus &&
              <div className="open-accounts sm-7 md-4 lg-3">
                <div className="sign-join-container ">
                  {account.signIn ?
                    <div className="signed" onClick={this._showProfile}>
                      <div className="profile">
                        <p className="name"><i className="icon-sign-in"/> Hi, {account.firstName}</p>
                        <button className="sign-out" onClick={this._showSignOutVerbiage}> Sign Out</button>
                      </div>
                      {!isMobile &&
                        <Fragment>
                          <p className="information">{pointsLabel} <span>{numberWithCommas(account.points ? account.points : 0)}</span></p>
                          <p className="information">Member ID: <span>{account.id}</span></p>
                          <p className="information">{levelLabel} <span>{account.level}</span></p>
                        </Fragment>
                      }
                      {isMobile &&
                        <Fragment>
                          <p className="information">Member ID: <span>{account.id}</span></p>
                          <p className="information">{pointsLabel} <span>{account.points}</span> {levelLabel} <span>{account.level}</span></p>
                        </Fragment>
                      }
                    </div>
                    :
                    <button className="sign-join" onClick={this._showLogin}><i className="icon-sign-in"/> Sign in or join</button>
                  }
                </div>
                {/* {showProfile &&
                  <div className="profile-options">
                    {this._createAccountOptions()}
                    <div key="xopt" className="option"><button onClick={this._showSignOutVerbiage}> <i className="icon-acc-signout" /> Sign Out</button></div>
                  </div>
                } */}
              </div>
            }
          </div>
        </div>
        {step !== 6 &&
        <section className="intro steps-section">
          <picture className="steps-bgs">
            <source media="(min-width:1163px)" srcSet="https://cdn.sandals.com/obe/v12/images/step1/vacation/steps-background.jpg"/>
            <source media="(min-width: 768px)" srcSet="https://cdn.sandals.com/obe/v12/images/step1/vacation/tablet-steps-bg.jpg"/>
            <img className="resolution-img" src="https://cdn.sandals.com/obe/v12/images/step1/vacation/mobile-steps-bg.jpg" alt="Blue Sky"/>
          </picture>
          <div className="row steps-row">
            {this.renderSteps()}
          </div>
        </section>}
        <Accounts brand={brand} showLogin={showLogin}/>
        {showLogin &&
          <div className="acc-hidden-block" />
        }
      </OutsideClickHandler>
    );
  }
}

Header.propTypes = {
  brand: PropTypes.string,
};

Header.defaultProps = {
  brand: `${sandals}`,
};

export default Header;



// WEBPACK FOOTER //
// ./js/components/global/Header.js